import styled from 'styled-components';
import { Card } from 'antd';

// Styled components for Campaigns page
export const CampaignNameLink = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.settings.primary};
`;

// New Campaign Card matching Figma design
export const CampaignCard = styled(Card)`
  width: 100%;
  border-radius: 12px;
  border: 1px solid #e2e8ee;
  background: ${({ theme }) => theme.settings.whiteColor};
  box-shadow: 0px 0px 8px rgba(50, 50, 50, 0.05);
  cursor: pointer;
  transition: all 0.2s ease;
  scale: 1;
  &:hover {
    scale: 1.02;
    box-shadow: 0px 4px 8px rgba(50, 50, 50, 0.1);
    border-color: ${({ theme }) => theme.settings.borderColor};
    transition: all 0.2s ease;
  }

  .ant-card-body {
    padding: 0;
  }

  &.ant-card-loading {
    .ant-card-body {
      padding: 20px 24px;
    }
  }
`;

export const CampaignCardInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 24px;
`;

export const CampaignCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CampaignCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const CampaignCardTitle = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.settings.tertiary};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CampaignCardSubtitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.settings.tertiary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CampaignCardContent = styled.div`
  padding: 16px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CampaignCardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CampaignCardMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) => theme.settings.secondary};
  margin-top: 4px;

  .meta-left {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    color: ${({ theme }) => theme.settings.tertiary};

    img {
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
  }
`;

export const CampaignCardDate = styled.div`
  display: inline-flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: ${({ theme }) => theme.settings.textColor};

  img {
    width: 14px;
    height: 14px;
    margin-right: 6px;
    flex-shrink: 0;
  }
`;

export const TableActionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const CardMenuIcon = styled.span`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 4px;
  border-radius: 4px;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }

  img {
    width: 24px;
    height: 24px;
  }
`;
export const ForbiddenWrapper = styled.div`
  text-align: center;
  padding: 50px;
`;
export const StatusBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 8px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: ${({ theme }) => theme.settings.primary};
  .status-icon {
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
